import * as yup from 'yup';

const fields = {
    root: [{
        component: 'input',
        id: 'kml',
        name: 'kml',
        label: 'KML *',
        type: 'file',
        col: 6,
        fullWidth: true,
        validation: yup.mixed()
        .nullable()
        .required('Campo obrigatório')
        .test("FILE_FORMAT", "O Arquivo deve ser um PDF", 
            value => !value || (value && ['application/pdf'].includes(value.type)))
    },
    {
        component: 'input',
        id: 'title',
        name: 'title',
        label: 'Nome (Exibição da lista) *',
        type: 'text',
        col: 6,
        fullWidth: true,
        validation: yup.string().required('Campo obrigatório')
    },
    {
        component: 'input',
        id: 'name',
        name: 'name',
        label: 'Nome completo da Propriedade *',
        type: 'text',
        col: 6,
        fullWidth: true,
        validation: yup.string().required('Campo obrigatório')
    },
    {
        component: 'input',
        id: 'coords',
        name: 'coords',
        label: 'Coordenadas (exibição na lista) *',
        type: 'text',
        col: 10,
        fullWidth: true,
        validation: yup.string().required('Campo obrigatório')
    },
    {
        component: 'input',
        id: 'cnpj',
        name: 'cnpj',
        label: 'CNPJ *',
        type: 'text',
        mask: 'cnpj',
        col: 2,
        fullWidth: true,
        validation: yup.string().required('Campo obrigatório')
    },
    {
        component: 'checkbox',
        type: 'checkbox',
        id: 'hasElaw',
        name: 'hasElaw',
        label: 'Existem procedimentos nesse imóvel',
        col: 12,
        validation: yup.bool().oneOf([true], 'Por favor escolha uma opção')
    },
    {
        component: 'input',
        id: 'elaw',
        name: 'elaw',
        label: 'Sistema Jurídico *',
        type: 'text',
        col: 4,
        fullWidth: true,
        validation: yup.string().required('Campo obrigatório')
    }
    ],
    licensingWaiver: [
        {
            component: 'input',
            id: 'organ',
            name: 'organ',
            label: 'Orgão *',
            type: 'text',
            col: 6,
            fullWidth: true,
            validation: yup.string().required('Campo obrigatório')
        },
        {
            component: 'input',
            id: 'startDate',
            name: 'startDate',
            label: 'Data de início *',
            type: 'date',
            col: 6,
            fullWidth: true,
            validation: yup.string().required('Campo obrigatório')
        },
        {
            component: 'input',
            id: 'endDate',
            name: 'endDate',
            label: 'Data de validade *',
            type: 'date',
            col: 6,
            fullWidth: true,
            validation: yup.string().required('Campo obrigatório')
        },
        {
            component: 'input',
            id: 'activity',
            name: 'activity',
            label: 'Atividade *',
            type: 'text',
            col: 6,
            fullWidth: true,
            validation: yup.string().required('Campo obrigatório')
        },
        {
            component: 'input',
            id: 'fileChose',
            name: 'fileChose',
            label: 'Arquivo (PDF)',
            type: 'file',
            col: 6,
            fullWidth: false,
            accept: 'application/pdf'
        },
        {
            component: 'input',
            id: 'file',
            name: 'file',
            label: null,
            type: 'text',
            col: 6,
            className: 'display--none',
            fullWidth: false
        },
        {
            component: 'input',
            id: 'title',
            name: 'title',
            label: 'Título (Nome do arquivo exibido no botão de download)',
            type: 'text',
            col: 6,
            fullWidth: false
        },
        {
            component: 'input',
            id: 'comments',
            name: 'comments',
            label: 'Comentários',
            type: 'textarea',
            col: 6,
            fullWidth: true
        },
        {
            component: 'submit',
            name: 'submit',
            value: 'Adicionar Dispença de Licenciamento',
            variant: 'plus',
            size: 'small',
            col: 4,
            fullWidth: true
        }
    ],
    environmentalLicense: [
        {
            component: 'input',
            id: 'organ',
            name: 'organ',
            label: 'Orgão *',
            type: 'text',
            col: 6,
            fullWidth: true,
            validation: yup.string().required('Campo obrigatório')
        },
        {
            component: 'input',
            id: 'startDate',
            name: 'startDate',
            label: 'Data de início *',
            type: 'date',
            col: 6,
            fullWidth: true,
            validation: yup.string().required('Campo obrigatório')
        },
        {
            component: 'input',
            id: 'endDate',
            name: 'endDate',
            label: 'Data de validade *',
            type: 'date',
            col: 6,
            fullWidth: true,
            validation: yup.string().required('Campo obrigatório')
        },
        {
            component: 'input',
            id: 'activity',
            name: 'activity',
            label: 'Atividade *',
            type: 'text',
            col: 6,
            fullWidth: true,
            validation: yup.string().required('Campo obrigatório')
        },
        {
            component: 'input',
            id: 'fileChose',
            name: 'fileChose',
            label: 'Arquivo (PDF)',
            type: 'file',
            col: 6,
            fullWidth: false,
            accept: 'application/pdf'
        },
        {
            component: 'input',
            id: 'file',
            name: 'file',
            label: null,
            type: 'text',
            col: 6,
            className: 'display--none',
            fullWidth: false
        },
        {
            component: 'input',
            id: 'title',
            name: 'title',
            label: 'Título (Nome do arquivo exibido no botão de download)',
            type: 'text',
            col: 6,
            fullWidth: false
        },
        {
            component: 'input',
            id: 'comments',
            name: 'comments',
            label: 'Comentários',
            type: 'textarea',
            col: 6,
            fullWidth: true
        },
        {
            component: 'submit',
            name: 'submit',
            value: 'Adicionar Licença Ambiental',
            variant: 'plus',
            size: 'small',
            col: 4,
            fullWidth: true
        }
    ],
    noticeInfraction: [
        {
            component: 'input',
            id: 'organ',
            name: 'organ',
            label: 'Orgão *',
            type: 'text',
            col: 6,
            fullWidth: true,
            validation: yup.string().required('Campo obrigatório')
        },
        {
            component: 'input',
            id: 'numberYear',
            name: 'numberYear',
            label: 'Número / Ano *',
            type: 'text',
            mask: 'numberYear',	
            col: 6,
            fullWidth: true,
            validation: yup.string().required('Campo obrigatório')
        },
        {
            component: 'input',
            id: 'fineAmount',
            name: 'fineAmount',
            label: 'Valor da Multa (R$)',
            type: 'text',
            mask: 'currency',
            col: 6,
            fullWidth: true,
            validation: yup.string().required('Campo obrigatório')
        },
        {
            component: 'checkbox',
            type: 'checkbox',
            id: 'suspension',
            name: 'suspension',
            inline: true,
            label: 'Suspensão',
            col: 6,
            fullWidth: true
        },
        {
            component: 'checkbox',
            type: 'checkbox',
            id: 'embargo',
            name: 'embargo',
            inline: true,
            label: 'Embargo',
            col: 6,
            fullWidth: true
        },
        {
            component: 'input',
            id: 'fileChose',
            name: 'fileChose',
            label: 'Arquivo (PDF)',
            type: 'file',
            col: 6,
            fullWidth: false,
            accept: 'application/pdf'
        },
        {
            component: 'input',
            id: 'file',
            name: 'file',
            label: null,
            type: 'text',
            col: 6,
            className: 'display--none',
            fullWidth: false
        },
        {
            component: 'input',
            id: 'title',
            name: 'title',
            label: 'Título (Nome do arquivo exibido no botão de download)',
            type: 'text',
            col: 6,
            fullWidth: true
        },
        {
            component: 'input',
            id: 'comments',
            name: 'comments',
            label: 'Comentários',
            type: 'textarea',
            col: 6,
            fullWidth: true
        },
        {
            component: 'submit',
            name: 'submit',
            value: 'Adicionar Auto de Infração',
            variant: 'plus',
            size: 'small',
            col: 4,
            fullWidth: true
        }
    ],
    tacAgency: [
        {
            component: 'input',
            id: 'organ',
            name: 'organ',
            label: 'Orgão *',
            type: 'text',
            col: 6,
            fullWidth: true,
            validation: yup.string().required('Campo obrigatório')
        },
        {
            component: 'input',
            id: 'signDate',
            name: 'signDate',
            label: 'Data de Assinatura *',
            type: 'date',
            col: 6,
            fullWidth: true,
            validation: yup.string().required('Campo obrigatório')
        },
        {
            component: 'input',
            id: 'number',
            name: 'number',
            label: 'Número *',
            type: 'text',
            col: 6,
            fullWidth: true,
            validation: yup.number().typeError('Insira um número válido').required('Campo obrigatório')
        },
        {
            component: 'input',
            id: 'fileChose',
            name: 'fileChose',
            label: 'Arquivo (PDF)',
            type: 'file',
            col: 6,
            fullWidth: false,
            accept: 'application/pdf'
        },
        {
            component: 'input',
            id: 'file',
            name: 'file',
            label: null,
            type: 'text',
            col: 6,
            className: 'display--none',
            fullWidth: false
        },
        {
            component: 'input',
            id: 'title',
            name: 'title',
            label: 'Título (Nome do arquivo exibido no botão de download)',
            type: 'text',
            col: 6,
            fullWidth: true
        },
        {
            component: 'input',
            id: 'comments',
            name: 'comments',
            label: 'Comentários',
            type: 'textarea',
            col: 6,
            fullWidth: true
        },
        {
            component: 'submit',
            name: 'submit',
            value: 'Adicionar TAC',
            variant: 'plus',
            size: 'small',
            col: 4,
            fullWidth: true
        }
    ],
    tacMp: [
        {
            component: 'input',
            id: 'organ',
            name: 'organ',
            label: 'Esfera do MP *',
            type: 'text',
            col: 6,
            fullWidth: true,
            validation: yup.string().required('Campo obrigatório')
        },
        {
            component: 'input',
            id: 'entity',
            name: 'entity',
            label: 'Promotoria / Entidade do MP *',
            type: 'text',
            col: 6,
            fullWidth: true,
            validation: yup.string().required('Campo obrigatório')
        },
        {
            component: 'input',
            id: 'signDate',
            name: 'signDate',
            label: 'Data de Assinatura *',
            type: 'date',
            col: 6,
            fullWidth: true,
            validation: yup.string().required('Campo obrigatório')
        },
        {
            component: 'input',
            id: 'number',
            name: 'number',
            label: 'Número *',
            type: 'text',
            col: 6,
            fullWidth: true,
            validation: yup.number().typeError('Insira um número válido').required('Campo obrigatório')
        },
        {
            component: 'input',
            id: 'fileChose',
            name: 'fileChose',
            label: 'Arquivo (PDF)',
            type: 'file',
            col: 6,
            fullWidth: false,
            accept: 'application/pdf'
        },
        {
            component: 'input',
            id: 'file',
            name: 'file',
            label: null,
            type: 'text',
            col: 6,
            className: 'display--none',
            fullWidth: false
        },
        {
            component: 'input',
            id: 'title',
            name: 'title',
            label: 'Título (Nome do arquivo exibido no botão de download)',
            type: 'text',
            col: 6,
            fullWidth: true
        },
        {
            component: 'input',
            id: 'comments',
            name: 'comments',
            label: 'Comentários',
            type: 'textarea',
            col: 6,
            fullWidth: true
        },
        {
            component: 'submit',
            name: 'submit',
            value: 'Adicionar TAC',
            variant: 'plus',
            size: 'small',
            col: 4,
            fullWidth: true
        }
    ],
    otherAdministrativeProcesses: [
        {
            component: 'input',
            id: 'organ',
            name: 'organ',
            label: 'Órgão Público *',
            type: 'text',
            col: 6,
            fullWidth: true,
            validation: yup.string().required('Campo obrigatório')
        },
        {
            component: 'input',
            id: 'number',
            name: 'number',
            label: 'Número *',
            type: 'text',
            col: 6,
            fullWidth: true,
            validation: yup.string().required('Campo obrigatório')
        },
        {
            component: 'input',
            id: 'subject',
            name: 'subject',
            label: 'Assunto *',
            type: 'text',
            col: 6,
            fullWidth: true,
            validation: yup.string().required('Campo obrigatório')
        },
        {
            component: 'input',
            id: 'startDate',
            name: 'startDate',
            label: 'Data de Início',
            type: 'date',
            col: 6,
            fullWidth: true
        },

        {
            component: 'input',
            id: 'fileChose',
            name: 'fileChose',
            label: 'Arquivo (PDF)',
            type: 'file',
            col: 6,
            fullWidth: false,
            accept: 'application/pdf'
        },
        {
            component: 'input',
            id: 'file',
            name: 'file',
            label: null,
            type: 'text',
            col: 6,
            className: 'display--none',
            fullWidth: false
        },
        {
            component: 'input',
            id: 'title',
            name: 'title',
            label: 'Título (Nome do arquivo exibido no botão de download)',
            type: 'text',
            col: 6,
            fullWidth: true
        },
        {
            component: 'input',
            id: 'comments',
            name: 'comments',
            label: 'Comentários',
            type: 'textarea',
            col: 6,
            fullWidth: true
        },
        {
            component: 'submit',
            name: 'submit',
            value: 'Adicionar Outros Processos Administrativos',
            variant: 'plus',
            size: 'small',
            col: 4,
            fullWidth: true
        }
    ],
    judicialProcess: [
        {
            component: 'input',
            id: 'court',
            name: 'court',
            label: 'Tribunal *',
            type: 'text',
            col: 6,
            fullWidth: true,
            validation: yup.string().required('Campo obrigatório')
        },
        {
            component: 'input',
            id: 'number',
            name: 'number',
            label: 'Número do Processo *',
            type: 'text',
            col: 6,
            fullWidth: true,
            validation: yup.string().required('Campo obrigatório')
        },
        {
            component: 'input',
            id: 'subject',
            name: 'subject',
            label: 'Assunto *',
            type: 'text',
            col: 6,
            fullWidth: true,
            validation: yup.string().required('Campo obrigatório')
        },
        {
            component: 'input',
            id: 'startDate',
            name: 'startDate',
            label: 'Data de Início',
            type: 'date',
            col: 6,
            fullWidth: true
        },
        {
            component: 'input',
            id: 'fileChose',
            name: 'fileChose',
            label: 'Arquivo (PDF)',
            type: 'file',
            col: 6,
            fullWidth: false,
            accept: 'application/pdf'
        },
        {
            component: 'input',
            id: 'file',
            name: 'file',
            label: null,
            type: 'text',
            col: 6,
            className: 'display--none',
            fullWidth: false
        },
        {
            component: 'input',
            id: 'title',
            name: 'title',
            label: 'Título (Nome do arquivo exibido no botão de download)',
            type: 'text',
            col: 6,
            fullWidth: true
        },
        {
            component: 'input',
            id: 'comments',
            name: 'comments',
            label: 'Comentários',
            type: 'textarea',
            col: 6,
            fullWidth: true
        },
        {
            component: 'submit',
            name: 'submit',
            value: 'Adicionar Processo Judicial',
            variant: 'plus',
            size: 'small',
            col: 4,
            fullWidth: true
        }
    ],
    car: [
        {
            component: 'input',
            id: 'number',
            name: 'number',
            label: 'Número *',
            type: 'text',
            col: 6,
            fullWidth: true,
            validation: yup.string().required('Campo obrigatório')
        },
        {
            component: 'submit',
            name: 'submit',
            value: 'Adicionar CAR',
            variant: 'plus',
            size: 'small',
            col: 4,
            fullWidth: true
        }
    ],
    dueDiligence: [
        {
            component: 'input',
            id: 'date',
            name: 'date',
            label: 'Data *',
            type: 'date',
            col: 6,
            fullWidth: true,
            validation: yup.string().required('Campo obrigatório')
        },
        {
            component: 'input',
            id: 'result',
            name: 'result',
            label: 'Resultado',
            type: 'textarea',
            col: 6,
            fullWidth: true
        },
        {
            component: 'input',
            id: 'comments',
            name: 'comments',
            label: 'Comentários',
            type: 'textarea',
            col: 6,
            fullWidth: true
        },
        {
            component: 'submit',
            name: 'submit',
            value: 'Adicionar Due Diligence',
            variant: 'plus',
            size: 'small',
            col: 4,
            fullWidth: true
        }
    ],
}


export default fields;